module.exports = __webpack_public_path__ + "img/C544.c4cffae3.jpg";